// == Page info
import {Info} from '@/vuex/modules/pageInfo/Info.js'

// == Bar charts
import {AddressTypes} from '@/vuex/modules/barCharts/AddressTypes.js'
import {CollisionTypes} from '@/vuex/modules/barCharts/CollisionTypes.js'
import {DamageCosts} from '@/vuex/modules/barCharts/DamageCosts.js'
import {JunctionTypes} from '@/vuex/modules/barCharts/JunctionTypes.js'
import {LightConditions} from '@/vuex/modules/barCharts/LightConditions.js'
import {RoadConditions} from '@/vuex/modules/barCharts/RoadConditions.js'
import {Weather} from '@/vuex/modules/barCharts/Weather.js'

// == Map
import {Locations} from '@/vuex/modules/maps/Locations.js'

// == Tables
import {Who} from '@/vuex/modules/tables/Who.js'

// == Trays
import {Collision} from '@/vuex/modules/trays/Collision.js'

const modules = {
  total: Info,

  addressTypes: AddressTypes,
  collision: Collision,
  collisionTypes: CollisionTypes,
  collisionLocations: Locations,
  damageCosts: DamageCosts,
  junctionTypes: JunctionTypes,
  lightConditions: LightConditions,
  roadConditions: RoadConditions,
  weather: Weather,
  who: Who
}

const state = {
  resultsFilters: {}
}

const mutations = {
  SET_RESULTS_FILTERS (state, filters) {
    state.resultsFilters = filters
  }
}

const actions = {
  fetchAll: function ({commit, dispatch}, filters) {
    commit('SET_RESULTS_FILTERS', filters)

    dispatch('total/fetch', {slug: '/collisions/total', filters: filters})
    dispatch('collisionLocations/fetch', {slug: '/collisions/locations', filters: filters})
    dispatch('who/fetch', filters)

    dispatch('addressTypes/fetch', {slug: '/address/types', filters: filters})
    dispatch('collisionTypes/fetch', {slug: '/collision/types', filters: filters})
    dispatch('damageCosts/fetch', {slug: '/damage/costs/economic', filters: filters})
    dispatch('junctionTypes/fetch', {slug: '/junction/types', filters: filters})
    dispatch('lightConditions/fetch', {slug: '/light/conditions', filters: filters})
    dispatch('roadConditions/fetch', {slug: '/road/conditions', filters: filters})
    dispatch('weather/fetch', {slug: '/weathers', filters: filters})
  },

  setFilters: function ({dispatch, rootState}) {
    dispatch('filterDateRange/setStartDate', rootState.route.params.sd, {root: true})
    dispatch('filterDateRange/setEndDate', rootState.route.params.ed, {root: true})
    dispatch('filterMapActive/set', rootState.route.params.m, {root: true})
    dispatch('filterMapBounds/set', {
      ne: {lat: rootState.route.params.nelat, lng: rootState.route.params.nelng},
      sw: {lat: rootState.route.params.swlat, lng: rootState.route.params.swlng}
    }, {root: true})
  },

  resetResults: function ({dispatch}) {
    dispatch('total/reset')

    dispatch('addressTypes/reset')
    dispatch('collisionLocations/reset')
    dispatch('collisionTypes/reset')
    dispatch('damageCosts/reset')
    dispatch('junctionTypes/reset')
    dispatch('lightConditions/reset')
    dispatch('roadConditions/reset')
    dispatch('weather/reset')
    dispatch('who/reset')
  }
}

const getters = {
  filters (state, getters, rootState) {
    return {
      startDate: rootState.filterDateRange.startDate,
      endDate: rootState.filterDateRange.endDate,
      map: {
        active: rootState.filterMapActive.active,
        bounds: rootState.filterMapBounds.bounds
      }
    }
  },

  resultsFilters: state => state.resultsFilters
}

export const CollisionsView = {
  namespaced: true,
  modules,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/views/CollisionsView.js